var _g, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function Svg11(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 133,
    height: 134,
    viewBox: "0 0 133 134",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_5137_19706)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 65.5,
    cy: 65,
    r: 47.5,
    fill: "white"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M56.9106 37.7471H45.457V54.4734H56.9106V37.7471Z",
    fill: "#F89358"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M58.4746 34.2217H45.7613C44.122 34.2217 42.793 35.5507 42.793 37.1901V39.6897C42.793 41.3291 44.122 42.6581 45.7613 42.6581H58.4746C60.1139 42.6581 61.4429 41.3291 61.4429 39.6897V37.1901C61.4429 35.5507 60.1139 34.2217 58.4746 34.2217Z",
    fill: "#F89358"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M79.6723 47.1404H45.4677C40.8515 47.1404 37.1094 50.8825 37.1094 55.4987V81.5403C37.1094 86.1564 40.8515 89.8986 45.4677 89.8986H79.6723C84.2885 89.8986 88.0306 86.1564 88.0306 81.5403V55.4987C88.0306 50.8825 84.2885 47.1404 79.6723 47.1404Z",
    fill: "#F89358"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M80.1901 47.1404H47.6552C43.3249 47.1404 39.8145 50.6508 39.8145 54.9812V78.9722C39.8145 83.3026 43.3249 86.813 47.6552 86.813H80.1901C84.5205 86.813 88.0309 83.3026 88.0309 78.9722V54.9812C88.0309 50.6508 84.5205 47.1404 80.1901 47.1404Z",
    fill: "#FFB762"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M72.9453 60.4394V50.5579H80.9228C81.9587 50.5579 82.9521 50.9694 83.6846 51.7018C84.4171 52.4343 84.8286 53.4277 84.8286 54.4636V60.4492L72.9453 60.4394Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M58.7661 37.7471H47.3125V54.4734H58.7661V37.7471Z",
    fill: "#FFB762"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M58.758 34.2217H47.3239C45.8355 34.2217 44.6289 35.4283 44.6289 36.9166V39.2308C44.6289 40.7192 45.8355 41.9258 47.3239 41.9258H58.758C60.2463 41.9258 61.4529 40.7192 61.4529 39.2308V36.9166C61.4529 35.4283 60.2463 34.2217 58.758 34.2217Z",
    fill: "#FFB762"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M79.7305 97.7471C89.8312 97.7471 98.0195 89.5588 98.0195 79.458C98.0195 69.3572 89.8312 61.1689 79.7305 61.1689C69.6297 61.1689 61.4414 69.3572 61.4414 79.458C61.4414 89.5588 69.6297 97.7471 79.7305 97.7471Z",
    fill: "#00C65E"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M79.7302 93.3598C87.4081 93.3598 93.6323 87.1356 93.6323 79.4577C93.6323 71.7798 87.4081 65.5557 79.7302 65.5557C72.0523 65.5557 65.8281 71.7798 65.8281 79.4577C65.8281 87.1356 72.0523 93.3598 79.7302 93.3598Z",
    fill: "#CCE7D7"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M79.7308 85.6259C82.9789 85.6259 85.612 82.9928 85.612 79.7447C85.612 76.4966 82.9789 73.8635 79.7308 73.8635C76.4827 73.8635 73.8496 76.4966 73.8496 79.7447C73.8496 82.9928 76.4827 85.6259 79.7308 85.6259Z",
    fill: "white"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M79.7311 83.9642C82.22 83.9642 84.2376 81.9466 84.2376 79.4577C84.2376 76.9688 82.22 74.9512 79.7311 74.9512C77.2422 74.9512 75.2246 76.9688 75.2246 79.4577C75.2246 81.9466 77.2422 83.9642 79.7311 83.9642Z",
    fill: "#00C65E"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M80.3265 79.002H79.1191V94.458H80.3265V79.002Z",
    fill: "#00C65E"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M80.3265 64.2878H79.1191V79.7439H80.3265V64.2878Z",
    fill: "#00C65E"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M79.9688 78.7751V79.9824H95.4248V78.7751H79.9688Z",
    fill: "#00C65E"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M65.2539 78.7636V79.9709H80.7099V78.7636H65.2539Z",
    fill: "#00C65E"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M79.9575 79.1217L79.1074 79.979L90.0822 90.8622L90.9323 90.0049L79.9575 79.1217Z",
    fill: "#00C65E"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M69.5103 68.7594L68.6602 69.6167L79.6349 80.4999L80.485 79.6426L69.5103 68.7594Z",
    fill: "#00C65E"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M79.5314 79.2134L80.3887 80.0635L91.2719 69.0887L90.4146 68.2386L79.5314 79.2134Z",
    fill: "#00C65E"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M69.1798 89.6589L70.0371 90.509L80.9203 79.5343L80.063 78.6842L69.1798 89.6589Z",
    fill: "#00C65E"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M79.7311 82.1713C81.2297 82.1713 82.4445 80.9565 82.4445 79.4579C82.4445 77.9592 81.2297 76.7444 79.7311 76.7444C78.2324 76.7444 77.0176 77.9592 77.0176 79.4579C77.0176 80.9565 78.2324 82.1713 79.7311 82.1713Z",
    fill: "white"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M53.8016 89.4841L60.8016 87.8541L53.8016 86.1941L52.1216 79.7441L50.4316 86.1941L43.4316 87.8541L50.3716 89.4841L52.1616 96.2741L53.8016 89.4841Z",
    fill: "#00C65E"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M45.6885 75.458L49.7785 74.458L45.6285 73.458L44.6285 69.668L43.6285 73.458L39.4785 74.458L43.5685 75.458L44.5685 79.458L45.6885 75.458Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_5137_19706",
    x: 0,
    y: 0.5,
    width: 133,
    height: 133,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 3,
    operator: "dilate",
    in: "SourceAlpha",
    result: "effect1_dropShadow_5137_19706"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 1,
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 8
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.211765 0 0 0 0 0.227451 0 0 0 0 0.270588 0 0 0 0.08 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_5137_19706"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_5137_19706",
    result: "shape"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(Svg11);
export default __webpack_public_path__ + "static/media/11.f6df4e1b4499b1af2731aee900fc8d65.svg";
export { ForwardRef as ReactComponent };